import React from "react";
import './TermsPrivacy.css';

const TermsPrivacy = ({ isAlbanian }) => {
  return (
    <div className={isAlbanian ? 'terms-container-albanian' : 'terms-container-english'}>
      <h1>{isAlbanian ? 'Termat dhe Kushtet për Vila-L' : 'Terms and Conditions for Vila-L'}</h1>
      <h2>{isAlbanian ? 'Ky dokument u përditësua më: 03 Shkurt, 2025' : 'Last updated: February 03, 2025'}</h2>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Interpretimi dhe Definicioni' : 'Interpretation and Definitions'}</h3>
        <p><strong>{isAlbanian ? 'Interpretimi' : 'Interpretation'}</strong><br />
          {isAlbanian
            ? 'Fjalët që kanë shkronjën e madhe kanë kuptimin e përcaktuar në kushtet e mëposhtme. Këto definita do të kenë të njëjtin kuptim pavarësisht nëse janë në njëjës apo shumës.'
            : 'The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or plural.'
          }
        </p>
        <p><strong>{isAlbanian ? 'Definicioni' : 'Definitions'}</strong><br />
          {isAlbanian
            ? 'Për qëllimet e këtyre Kushteve dhe Kushtet:'
            : 'For the purposes of these Terms and Conditions:'
          }
        </p>
        <ul>
          <li>{isAlbanian ? 'Afiliu do të thotë një entitet që kontrollon, kontrollohet nga, ose është nën kontroll të përbashkët me një palë.' : 'Affiliate means an entity that controls, is controlled by, or is under common control with a party.'}</li>
          <li>{isAlbanian ? 'Vendi do të thotë: Shqipëri' : 'Country refers to: Albania'}</li>
          <li>{isAlbanian ? 'Shërbimi do të thotë Uebfaqja.' : 'Service refers to the Website.'}</li>
          <li>{isAlbanian ? 'Uebfaqja do të thotë Vila-L, e arritshme nga https://vila-l.com/' : 'Website refers to Vila-L, accessible from https://vila-l.com/'}</li>
          <li>{isAlbanian ? 'Ju do të thotë individi që ka akses ose përdor shërbimin, ose kompania ose entiteti juridik që përdor shërbimin në emër të individit.' : 'You means the individual accessing or using the Service, or the company or legal entity on behalf of which such individual is accessing or using the Service.'}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Shënim' : 'Acknowledgment'}</h3>
        <p>
          {isAlbanian
            ? 'Këto janë Kushtet dhe Kushtet që rregullojnë përdorimin e këtij Shërbimi dhe marrëveshjen që operon mes Jush dhe Kompanisë. Pasi të keni hyrë ose përdorur Shërbimin, ju pranoni të jeni të lidhur me këto Kushtet dhe Kushtet.'
            : 'These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. By accessing or using the Service, You agree to be bound by these Terms and Conditions.'
          }
        </p>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Lidhjet me Uebfaqe të Tjera' : 'Links to Other Websites'}</h3>
        <p>
          {isAlbanian
            ? 'Shërbimi ynë mund të përmbajë lidhje me faqe uebi të palëve të treta që nuk janë nën kontrollin e Kompanisë. Kompania nuk ka kontroll mbi këto faqe dhe nuk merr përgjegjësi për përmbajtjen ose praktikat e privatësisë së tyre.'
            : 'Our Service may contain links to third-party websites or services that are not owned or controlled by the Company. The Company has no control over these third-party websites or services and assumes no responsibility for their content or privacy practices.'
          }
        </p>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Pushimi i Përdorimit' : 'Termination'}</h3>
        <p>
          {isAlbanian
            ? 'Ne mund të pezullojmë ose përfundojmë menjëherë aksesin tuaj pa njoftim paraprak për çdo arsye, përfshirë shkeljen e këtyre Kushteve dhe Kushtet.'
            : 'We may terminate or suspend Your access immediately, without prior notice, for any reason, including if You breach these Terms and Conditions.'
          }
        </p>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Limiti i Pëgjegjësisë' : 'Limitation of Liability'}</h3>
        <p>
          {isAlbanian
            ? 'Pëgjegjësia e Kompanisë dhe e furnitorëve të saj do të kufizohet në shumën që keni paguar përmes Shërbimit ose 100 USD nëse nuk keni blerë asgjë përmes Shërbimit.'
            : 'The liability of the Company and any of its suppliers shall be limited to the amount actually paid by You through the Service or 100 USD if You haven’t purchased anything through the Service.'
          }
        </p>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Ligji Rregullues' : 'Governing Law'}</h3>
        <p>
          {isAlbanian
            ? 'Ligjet e Vendit, përveç rregullave të saj të konfliktit të ligjit, do të rregullojnë këto Kushte dhe përdorimin tuaj të Shërbimit.'
            : 'The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service.'
          }
        </p>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Ndryshimet në Këto Kushte dhe Kushtet' : 'Changes to These Terms and Conditions'}</h3>
        <p>
          {isAlbanian
            ? 'Ne rezervojmë të drejtën për të modifikuar ose zëvendësuar këto Kushte në çdo kohë. Nëse një rishikim është i rëndësishëm, do të bëjmë përpjekje të arsyeshme për t\'ju njoftuar të paktën 30 ditë përpara se të hyjnë në fuqi kushtet e reja.'
            : 'We reserve the right to modify or replace these Terms at any time. If a revision is material, We will make reasonable efforts to provide at least 30 days\' notice.'
          }
        </p>
      </section>

      <section className="terms-section">
        <h3>{isAlbanian ? 'Kontaktoni Ne' : 'Contact Us'}</h3>
        <p>
          {isAlbanian
            ? 'Nëse keni ndonjë pyetje lidhur me këto Kushtet dhe Kushtet, mund të na kontaktoni me email: <a href="mailto:info@vila-l.com">info@vila-l.com</a>'
            : 'If you have any questions about these Terms and Conditions, You can contact us by email: <a href="mailto:info@vila-l.com">info@vila-l.com</a>'
          }
        </p>
      </section>
    </div>
  );
};

export default TermsPrivacy;
